export default __webpack_public_path__ + "static/media/work-3.3a166571.gif";